import type { Template } from "./types/templates.types";
import { blankInit } from "./blank/init";
import { cleaningServicesInit } from "./cleaning-services/init";
import { cleanProTemplate } from "./clean-pro/init";
import { simpleCleaningInit } from "./simple-cleaning/init";

const TEMPLATE_CONFIGS: Template[] = [cleaningServicesInit, cleanProTemplate, simpleCleaningInit];

export const TEMPLATES: Template[] = TEMPLATE_CONFIGS;
